const searchQueryParamName = "szukaj";
export default searchQueryParamName;